import { apiService } from './api.service';

export type EvidenceCategory = 'PAYMENT' | 'SIGNAGE';

export type EvidenceInitResponse = {
  evidenceId: string;
  storagePath: string;
  uploadUrl: string;
};

export type EvidenceCompleteResponse = {
  evidenceId: string;
  status: string;
  extracted?: any;
  summary?: string;
  uiSummary?: string | null;
  confidence?: 'low' | 'medium' | 'high';
  confirmPrompt?: {
    message: string;
    quickReplies: string[];
    stepKey: string;
  };
};

export const evidenceService = {
  initUpload(
    sessionId: string,
    payload: { category: EvidenceCategory; contentType: string; sizeBytes: number }
  ): Promise<EvidenceInitResponse> {
    return apiService.initSessionEvidence(sessionId, payload).then((response) => {
      return (response.data || response) as EvidenceInitResponse;
    });
  },

  completeUpload(
    sessionId: string,
    evidenceId: string,
    file: File,
    payload?: { language?: string }
  ): Promise<EvidenceCompleteResponse> {
    return apiService.completeSessionEvidence(sessionId, evidenceId, file, payload).then((response) => {
      return (response.data || response) as EvidenceCompleteResponse;
    });
  },

  confirmEvidence(
    sessionId: string,
    evidenceId: string,
    payload: { confirmed: boolean; correction?: string }
  ): Promise<{ evidenceId: string; confirmed: boolean }> {
    return apiService.confirmSessionEvidence(sessionId, evidenceId, payload).then((response) => {
      return (response.data || response) as { evidenceId: string; confirmed: boolean };
    });
  },
};

export default evidenceService;
